module.exports = __webpack_public_path__ + "img/04.616fdf6b.png";